import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss() {
    const el = this.element
    el.classList.add("opacity-0", "-translate-y-2", "pointer-events-none")

    const done = () => { el.remove() }
    el.addEventListener("transitionend", done, { once: true })
    setTimeout(done, 400)
  }
}
